import http from '../helpers/http';

const VacationKids = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async (kidsId: string) => {
      const result = await http.get(`/kids/${kidsId}/vacations-kids`, {
        headers,
      });
      return result.data;
    },
    create: async (body: { vacationTime: string; startDate: string; endDate: string }, kidsId: string) => {
      const result = await http.post(`/kids/${kidsId}/vacations-kids`, body, { headers });
      return result.data;
    },
    update: async (body: { discountsId: string; startDate: string; endDate: string }, kidsId: string, id: string) => {
      const result = await http.put(`/kids/${kidsId}/discounts-kids/${id}`, body, {
        headers,
      });
      return result.data;
    },
    delete: async (kidsId: string, id: string) => {
      const result = await http.delete(`/kids/${kidsId}/vacations-kids/${id}`, {
        headers,
      });
      return result.data;
    },
    totalAvaliableVacationWeeks: async (kidsId: string) => {
      const result = await http.get(`/kids/${kidsId}/vacations-kids/total-available-vacation-weeks`, {
        headers,
      });
      return result.data;
    },
  };
};

export default VacationKids;
